import { translatableValueZodObject } from "@@/shared/translations/translation";
import { z } from "zod";

const productFormFieldSelectOptionZodObject = z.object({
    label: translatableValueZodObject,
    value: z.string(),
    iconName: z.string().optional(),
});
type ProductFormField_SelectOption = z.infer<
    typeof productFormFieldSelectOptionZodObject
>;

const factory = (
    input: ProductFormField_SelectOption,
): ProductFormField_SelectOption => {
    return input;
};

export {
    factory as productFormFieldSelectOptionFactory,
    productFormFieldSelectOptionZodObject,
};
export type { ProductFormField_SelectOption };
